import { ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';

import { themeColors } from 'colors';

export type ToggleSelectorOption = {
    value: string;
    label: string;
    ariaLabel: string;
    testId: string;
};

export type Props = {
    value: string;
    options: ToggleSelectorOption[];
    onChange: (value: string) => void;
    title?: string;
    testId?: string;
};

const toggleButtonSx = {
    textTransform: 'lowercase',
    px: 3,
    py: 1,
    '&.Mui-selected': {
        backgroundColor: themeColors.action.active,
        color: 'white',
        '&:hover': {
            backgroundColor: themeColors.action.selected,
        },
    },
};

const ToggleSelector = ({ value, options, onChange, title, testId = 'toggle-selector' }: Props) => (
    <>
        <ToggleButtonGroup
            value={value}
            exclusive
            onChange={(_, newValue) => {
                if (newValue !== null) {
                    onChange(newValue);
                }
            }}
            aria-label="toggle selection"
            data-testid={testId}
            role="group"
            sx={{ mb: 3 }}
        >
            {options.map((option) => (
                <ToggleButton
                    key={option.value}
                    value={option.value}
                    aria-label={option.ariaLabel}
                    data-testid={option.testId}
                    sx={toggleButtonSx}
                >
                    {option.label}
                </ToggleButton>
            ))}
        </ToggleButtonGroup>

        {title && (
            <Typography
                variant="h6"
                data-testid="toggle-title"
                sx={{
                    mb: 2,
                    color: themeColors.text.primary,
                    textTransform: 'lowercase',
                }}
            >
                {title}
            </Typography>
        )}
    </>
);

export default ToggleSelector;
